import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Vendors/VendorProfile';

const OrgViewSellerRequest = () => ((orgContainer(InnerComponent)));
export default OrgViewSellerRequest;
